import styled from 'styled-components';

export default styled.div`
  top: 1px;
  position: absolute;
  right: 1px;
  height: calc(100% - 2px);
  padding: 1.5rem;
  color: #999;
  cursor: pointer;
  background: #fff;
  border-left: 1px solid #f4f4f4;
  
  &:hover {
    color: #000;
  }
`;
